import Box from "@mui/material/Box";
import {
  Button,
  Grid,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tooltip,
} from "@mui/material";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import { PostAPI } from "../../Components/Backend/PostAPI";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import APIAxios from "../../Api/APIAxios";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import PageTitle from "../../Components/Layout/PageTitle";

export default function CalendarioRegistration() {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(6); //Jornadas
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */
  //***************************************   SALVAR e SALVAR + NOVO ********************************* */
  const [modoIncluirMais, setModoIncluirMais] = useState(false);
  //************************************************************************************************** */
  const apiAxios = APIAxios();
  const navigate = useNavigate();

  const [diaSemana, setDiaSemana] = useState([
    {
      dia: 1,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
    {
      dia: 2,
      minutos: 540,
      horaIniP1: "08:00:00",
      horaFimP1: "12:00:00",
      horaIniP2: "13:00:00",
      horaFimP2: "18:00:00",
    },
    {
      dia: 3,
      minutos: 540,
      horaIniP1: "08:00:00",
      horaFimP1: "12:00:00",
      horaIniP2: "13:00:00",
      horaFimP2: "18:00:00",
    },
    {
      dia: 4,
      minutos: 540,
      horaIniP1: "08:00:00",
      horaFimP1: "12:00:00",
      horaIniP2: "13:00:00",
      horaFimP2: "18:00:00",
    },
    {
      dia: 5,
      minutos: 540,
      horaIniP1: "08:00:00",
      horaFimP1: "12:00:00",
      horaIniP2: "13:00:00",
      horaFimP2: "18:00:00",
    },
    {
      dia: 6,
      minutos: 480,
      horaIniP1: "08:00:00",
      horaFimP1: "12:00:00",
      horaIniP2: "13:00:00",
      horaFimP2: "17:00:00",
    },
    {
      dia: 7,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
  ]);

  const [semana, setSemana] = useState([
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sabado",
  ]);

  const [formData, setFormData] = useState({
    idEmpresa: 0,
    descricao: "",
    status: "A",
    dias: diaSemana,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeDias = (index, field, value) => {
    const newDias = [...diaSemana];
    newDias[index][field] = value;
    setDiaSemana(newDias);
  };

  const handleCopyDias = (index) => {
    const newDias = [...diaSemana];

    newDias.map((reg) => {
      if (reg.dia > 2 && reg.dia < 7) {
        reg.horaIniP1 = diaSemana[index].horaIniP1;
        reg.horaFimP1 = diaSemana[index].horaFimP1;
        reg.horaIniP2 = diaSemana[index].horaIniP2;
        reg.horaFimP2 = diaSemana[index].horaFimP2;
        reg.minutos = diaSemana[index].minutos;
      }
    });
    setDiaSemana(newDias);
  };

  const handleVoltar = () => {
    navigate("/jornadas");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setAvisoErro("");
    setAvisoSucesso("");

    const response = await PostAPI(apiAxios, "/calendario", formData);

    setLoading(false);

    if (response.success) {
      setFormData(response.data);

      //Exibe mensagem de sucesso por 5 segundos e limpa a tela
      setAvisoSucesso("Jornada incluída com sucesso!");
      if (modoIncluirMais) {
        limparCampos();
      } else {
        await new Promise((resolve) => setTimeout(resolve, 3000)); // aguarda 3 segundos
        navigate("/jornadas");
      }
    } else {
      setAvisoErro(response.errorMessage || "Erro ao incluir o médico.");
    }
  };

  const limparCampos = () => {
    setDiaSemana([
      {
        dia: 1,
        minutos: 0,
        horaIniP1: null,
        horaFimP1: null,
        horaIniP2: null,
        horaFimP2: null,
      },
      {
        dia: 2,
        minutos: 540,
        horaIniP1: "08:00:00",
        horaFimP1: "12:00:00",
        horaIniP2: "13:00:00",
        horaFimP2: "18:00:00",
      },
      {
        dia: 3,
        minutos: 540,
        horaIniP1: "08:00:00",
        horaFimP1: "12:00:00",
        horaIniP2: "13:00:00",
        horaFimP2: "18:00:00",
      },
      {
        dia: 4,
        minutos: 540,
        horaIniP1: "08:00:00",
        horaFimP1: "12:00:00",
        horaIniP2: "13:00:00",
        horaFimP2: "18:00:00",
      },
      {
        dia: 5,
        minutos: 540,
        horaIniP1: "08:00:00",
        horaFimP1: "12:00:00",
        horaIniP2: "13:00:00",
        horaFimP2: "18:00:00",
      },
      {
        dia: 6,
        minutos: 480,
        horaIniP1: "08:00:00",
        horaFimP1: "12:00:00",
        horaIniP2: "13:00:00",
        horaFimP2: "17:00:00",
      },
      {
        dia: 7,
        minutos: 0,
        horaIniP1: null,
        horaFimP1: null,
        horaIniP2: null,
        horaFimP2: null,
      },
    ]);
    setFormData({
      idEmpresa: 0,
      descricao: "",
      status: "A",
      dias: diaSemana,
    });
  };

  return (
    <Box>
      {/***************************************** AVISOS **********************************/}
      <PageTitle
        caption="Cadastro de Jornada"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/***************************************** AVISOS **********************************/}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          padding: 2,
          gap: 2,
          backgroundColor: "transparent",
          borderRadius: 1,
        }}
      >
        {/* Campos de texto para entrada de dados do formulário */}
        <TextField
          label="Descrição"
          name="descricao"
          type="text"
          value={formData.descricao}
          onChange={handleChange}
          required
          InputLabelProps={{ shrink: true }}
          fullWidth
        />

        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#ffffffff", padding: "6px" }}>
              <TableRow sx={{ borderBottom: "none" }}>
                <TableCell
                  align="center"
                  rowSpan={2}
                  sx={{ borderBottom: "none", padding: "6px" }}
                >
                  Dia
                </TableCell>
                <TableCell
                  align="center"
                  colSpan={2}
                  sx={{ borderBottom: "none", padding: "6px" }}
                >
                  Período 1
                </TableCell>
                <TableCell
                  align="center"
                  colSpan={2}
                  sx={{ borderBottom: "none", padding: "6px" }}
                >
                  Período 2
                </TableCell>
                <TableCell
                  align="center"
                  rowSpan={2}
                  sx={{ borderBottom: "none", padding: "6px", width: "170px" }}
                >
                  Minutos
                </TableCell>
              </TableRow>
              <TableRow sx={{ borderBottom: "none" }}>
                <TableCell
                  align="center"
                  sx={{ borderBottom: "none", padding: "6px" }}
                >
                  Entrada
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ borderBottom: "none", padding: "6px" }}
                >
                  Saída
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ borderBottom: "none", padding: "6px" }}
                >
                  Entrada
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ borderBottom: "none", padding: "6px" }}
                >
                  Saída
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {diaSemana.map((reg, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{semana[reg.dia - 1]}</TableCell>
                  <TableCell align="center">
                    <TextField
                      type="time"
                      value={reg.horaIniP1}
                      onChange={(e) =>
                        handleChangeDias(index, "horaIniP1", e.target.value)
                      }
                      fullWidth
                      size="small"
                      inputProps={{
                        step: 1,
                        style: { textAlign: "center" }, // Centraliza o texto
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      type="time"
                      value={reg.horaFimP1}
                      onChange={(e) =>
                        handleChangeDias(index, "horaFimP1", e.target.value)
                      }
                      fullWidth
                      size="small"
                      inputProps={{
                        step: 1,
                        style: { textAlign: "center" }, // Centraliza o texto
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      type="time"
                      value={reg.horaIniP2}
                      onChange={(e) =>
                        handleChangeDias(index, "horaIniP2", e.target.value)
                      }
                      fullWidth
                      size="small"
                      inputProps={{
                        step: 1,
                        style: { textAlign: "center" }, // Centraliza o texto
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      type="time"
                      value={reg.horaFimP2}
                      onChange={(e) =>
                        handleChangeDias(index, "horaFimP2", e.target.value)
                      }
                      fullWidth
                      size="small"
                      inputProps={{
                        step: 1,
                        style: { textAlign: "center" }, // Centraliza o texto
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Box display={"flex"} alignItems={"center"}>
                      <TextField
                        type="number"
                        value={reg.minutos}
                        onChange={(e) =>
                          handleChangeDias(index, "minutos", e.target.value)
                        }
                        fullWidth
                        size="small"
                        inputProps={{
                          style: { textAlign: "center" },
                        }}
                      />
                      {index === 1 && (
                        <Tooltip title="Copiar para outros dias">
                          <RestartAltIcon
                            size="small"
                            color="primary"
                            onClick={() => handleCopyDias(index)}
                          />
                        </Tooltip>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              justifyContent: "space-between", // separa esquerda e direita
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
              mt: 2,
            }}
          >
            <Box sx={{ width: { xs: "100%", md: "auto" } }}>
              <Button
                variant="contained"
                size="large"
                sx={{ backgroundColor: "#1a3865", xs: 12, md: 4, width: "100%" }}
                onClick={handleVoltar}
              >
                Voltar
              </Button>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                width: { xs: "100%", md: "auto" },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Button
                variant="outlined"
                size="large"
                type="submit"
                onClick={() => setModoIncluirMais(true)}
                sx={{
                  borderColor: "#1a3865",
                  color: "#1a3865",
                }}
              >
                Salvar + Incluir
              </Button>

              <Button
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                onClick={() => setModoIncluirMais(false)}
                sx={{
                  backgroundColor: "#1a3865",
                }}
              >
                Salvar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
